export default __webpack_public_path__ + "static/media/terraform.ccb2d02a.png";